import image1 from '../Assets/image1.jpg';
import image2 from '../Assets/image2.jpg';
import image3 from '../Assets/image3.jpg';

const Data = [
    {
        images: image1,
        review: `GymNex Fitness Center is my fitness sanctuary. The excellent equipment, motivating trainers, and friendly atmosphere have transformed my fitness journey. It's not just a gym; it's a life-changer!`,
        name: "ROBERT THOMPSON",
        status: "ENTERPRENEUR",
    },
    {
        images: image2,
        review: "GymNex Fitness Center is my fitness secret weapon. The exceptional equipment, expert trainers, and encouraging atmosphere have propelled me toward my fitness goals. It's more than a gym; it's my success partner",
        name: "AMELIA SMITH",
        status: "FOOTBALLER",
    },
    {
        images: image3,
        review: "GymNex Fitness Center has been my fitness oasis. The top-notch equipment, dedicated trainers, and warm environment have pushed me to achieve my goals. It's more than just a gym; it's my second home",
        name: "ALI ZAID",
        status: "BANKER",
    },
]

export default Data;